import { useQuery, useQueryClient } from '@tanstack/react-query';
import { useKeycloak } from '@react-keycloak/web';

interface ProductPayload {
  priceId: string;
}


interface Product {
  id: string;
}

export function useStripeProduct(payload: ProductPayload) {
  const queryClient = useQueryClient();
  const { keycloak } = useKeycloak();

  return useQuery({
    enabled: !!payload?.priceId,
    queryKey: ['stripeProduct', payload?.priceId],
    queryFn: async (): Promise<Product> => {

      const response = await fetch(
        `${import.meta.env.VITE_USER_ENGINE_ENDPOINT}/api/v1/bundles/user_bundle/functions/get_stripe_product`,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${keycloak.token}`
          },
          method: 'POST',
          body: payload ? JSON.stringify(payload) : '',
        }
      );

      let data = await response.json();

      const { product } = data?.data;

      return product;
    }
  });
}
